import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CertificateTableComponent } from './certificate-table/certificate-table.component';
import { CertificateViewComponent } from './certificate-view/certificate-view.component';
import { AuthGuard } from 'src/app/Guards/AuthGuard/auth.guard';
const certificateRoutes: Routes = [
{
  path: 'table/:viewType/:id',canActivate: [AuthGuard],
  component: CertificateTableComponent
},
{
  path: 'table/:viewType/:empid/:certificationType/:sno', canActivate: [AuthGuard],
   component: CertificateViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(certificateRoutes)],
  exports: [RouterModule]
})
export class CertificateRoutingModule { }
